import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import './assets/scss/index.scss';
import { ToastBar, Toaster } from 'react-hot-toast';
import Loader from './component/Loader';
import { loader } from './redux/reducers/loadingSlice';

const MainApp = () => {
  const loading = useSelector(loader);

  return (
    <>
      <Loader show={loading} />
      <React.StrictMode>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          gutter={8}
          reverseOrder
          containerClassName="custom-toast"
          containerStyle={{ right: '40px', bottom: '50px' }}
        >
          {(t) => (
            <ToastBar toast={t} style={{ padding: 0, overflow: 'hidden' }}>
              {({ icon, message }) => {
                return (
                  <div
                    className={`custom-toast-${t.type} flex items-center custom-toast-item`}
                  >
                    {icon}
                    {message}
                  </div>
                );
              }}
            </ToastBar>
          )}
        </Toaster>
      </React.StrictMode>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <MainApp />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
